// gpt
import { az_generate_onepage } from "@/pptjs/api/api_azure_openai.js";

// Pub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";

// i18n
import { i18n } from "@i18n";

// addin
import { add_slide_market_size } from "../util/gpt_onepage_market_size.js";

export function process_onepage_market_size(input) {
  // 本地添加一条消息
  let userLogText = "";
  if (input.taskType) {
    userLogText += i18n.t("ppt_addin.message.text_userlog_format_task");
    userLogText += input.taskType.title;
    if (input.taskOptions) {
      userLogText += ", ";
      userLogText += input.taskOptions.title;
    }
    userLogText += "<br />";
  }
  if (input.text.length > 0) {
    if (input.taskType) {
      userLogText += i18n.t(
        "ppt_addin.message.text_userlog_format_your_description"
      );
    }
    userLogText += input.text;
  }
  publish(gptPubIds.pubId_Local_Addin_UserLog, userLogText);

  // 调用接口
  // sample: 生成一个创业计划书，奶茶店，面向学生，选址在学校附近，原料新鲜口味好，每个店50平方米
  var params = {
    taskType: input.taskType ? input.taskType.id : "",
    taskOptions: input.taskOptions ? input.taskOptions.id : "",
    inputText: input.text, // + "，使用Markdown格式, 每一章节一定包含三级结构", //我正要写一个AI创业计划书，大纲应该是什么，请使用Markdown格式
  };
  az_generate_onepage(params).then(
    (response) => {
      handleChatGPTOpenAIResponse(response);
    },
    (error) => {
      handleChatGPTOpenAIError(error);
    }
  );
}

async function handleChatGPTOpenAIResponse(response) {
  if (response.data.Code === 0) {
    let gptMessage = response.data.Result.Content;
    await add_slide_market_size(gptMessage);
    publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
  }
}

// 单页PPT 市场规模
export async function createOnePagePPTMarketSize(responseMessage) {
  await add_slide_market_size(responseMessage);
  publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
}

function handleChatGPTOpenAIError(error) {
  if (error) {
    publish(
      gptPubIds.pubId_Local_Addin_SystemLog,
      i18n.t("ppt_addin.process.text_ppt_generating_content_failed")
    );
    publish(gptPubIds.pubId_Local_Gpt_Processing_Fail, "");
  }
}
